import { PartsProduct, PartsProductFromJSON } from '@app/react/const/type';

type ArrowType = string;
type OrderType = string;
type DefaultUnit = Record<ArrowType, Record<OrderType, any>>;
type RT = Record<ArrowType, Record<OrderType, PartsProduct>>;

export const toJsonDefaultUnit = (defaultUnit: DefaultUnit): RT => Object.keys(defaultUnit).reduce((acc, arrowType) => {
    if (defaultUnit[arrowType] === undefined || defaultUnit[arrowType] === null) {
        return acc;
    }
    Object.keys(defaultUnit[arrowType]).forEach((orderType) => {
        const value = defaultUnit[arrowType][orderType];
        if (value) {
            if (acc[arrowType] === undefined || acc[arrowType] === null) {
                acc[arrowType] = {};
            }
            acc[arrowType][orderType] = PartsProductFromJSON(value);
        }
    });
    return acc;
}, {} as RT);
